import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import Section from '../components/Section';
import SubscriptionModal from '../components/SubscriptionModal';
import { CustomPoojaRequest, DevoteeTestimonials } from '../components/DevoteeTestimonials';
import { ProviderNetworkCallout, ProviderNetworkModal, ProviderSearchInvitation } from '../components/ProviderNetworkModal';

const PPMainPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [poojas, setPoojas] = useState([]);
  const [showSubscription, setShowSubscription] = useState(false);
  const [subscriptionFlowEnabled, setSubscriptionFlowEnabled] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [publicCards, setPublicCards] = useState(null);
  const [providerModalMode, setProviderModalMode] = useState('register');
  const [showProviderModal, setShowProviderModal] = useState(() => new URLSearchParams(window.location.search).get('provider-network') === '1');

  const openProviderNetwork = (mode = 'register') => {
    setProviderModalMode(mode);
    setShowProviderModal(true);
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/poojas`)
      .then((res) => res.json())
      .then((data) => setPoojas(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error('Unable to load poojas', err);
        setPoojas([]);
      });

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/checkout-settings`)
      .then((res) => res.json())
      .then((data) => setSubscriptionFlowEnabled(Boolean(data?.subscriptionFlowEnabled)))
      .catch((err) => {
        console.error('Unable to load Pundit Purohit checkout settings', err);
        setSubscriptionFlowEnabled(false);
      });

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/testimonials`)
      .then((res) => res.json())
      .then((data) => setTestimonials(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error('Unable to load devotee testimonials', err);
        setTestimonials([]);
      });

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/public-cards`)
      .then((res) => res.json())
      .then((data) => setPublicCards(data && typeof data === 'object' ? data : null))
      .catch((err) => {
        console.error('Unable to load public PP card content', err);
        setPublicCards(null);
      });
  }, []);

  useEffect(() => {
    if (!subscriptionFlowEnabled) return;
    if (!sessionStorage.getItem('pp_subscription_prompt_seen')) {
      setShowSubscription(true);
      sessionStorage.setItem('pp_subscription_prompt_seen', 'true');
    }
  }, [subscriptionFlowEnabled]);

  // Filtering logic: checks if item name includes the search string
  const filterData = (data) =>
    data.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const filteredPoojas = filterData(poojas);
  // const filteredItems = filterData(poojaItems);
  // const filteredPundits = filterData(pundits);

  // Check if any results exist across all categories
  const hasResults =
    filteredPoojas.length > 0 

  return (
    <div className="pp-main-container">
      {subscriptionFlowEnabled && (
        <SubscriptionModal open={showSubscription} onClose={() => setShowSubscription(false)} />
      )}
      <ProviderNetworkModal
        open={showProviderModal}
        initialMode={providerModalMode}
        onClose={() => setShowProviderModal(false)}
      />
      {/* 1. Hero Section with search function passed as a prop */}
      <Hero onSearch={setSearchTerm} />

      <div className="pp-content-wrapper">
        <ProviderNetworkCallout content={publicCards?.providerPrimary} onRegister={() => openProviderNetwork('register')} onInvite={() => openProviderNetwork('referral')} />
        {!hasResults ? (
          /* 2. No Results State */
          <div className="no-results">
            <h3>No results found for "{searchTerm}"</h3>
            <p>Try searching for something else like "Ganesh" or "Deepak".</p>
            <button className="primary-btn" onClick={() => setSearchTerm('')}>
              Show All Products
            </button>
            <ProviderSearchInvitation content={publicCards?.providerSearchInvitation} onRegister={() => openProviderNetwork('register')} onInvite={() => openProviderNetwork('referral')} />
          </div>
        ) : (
          <>
            {/* 3. Render Sections only if they have matching items */}
            {filteredPoojas.length > 0 && (
              <Section 
                title="Poojas" 
                data={filteredPoojas} 
                link="/uc/pooja-library" 
                allowAddToCart 
              />
            )}

            {/* {filteredItems.length > 0 && (
              <Section 
                title="Pooja Items" 
                data={filteredItems} 
                link="/uc/pooja-items" 
                allowAddToCart 
              />
            )}

            {filteredPundits.length > 0 && (
              <Section 
                title="Pundits" 
                data={filteredPundits} 
                link="/uc/pundits" 
                allowAddToCart 
              />
            )} */}
          </>
        )}
      </div>
      <div className="pp-content-wrapper pp-community-content">
        <DevoteeTestimonials testimonials={testimonials} />
        <CustomPoojaRequest content={publicCards?.customPooja} />
        <ProviderNetworkCallout compact content={publicCards?.providerCompact} onRegister={() => openProviderNetwork('register')} onInvite={() => openProviderNetwork('referral')} />
      </div>
    </div>
  );
};

export default PPMainPage;
